import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-nav-store',
  templateUrl: './nav-store.component.html',
  styleUrls: ['./nav-store.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class NavStoreComponent implements OnInit {
  data: any;
  title: string = 'COMERCIO';

  constructor() { }

  ngOnInit(): void {

    this.data = this.shopItems;

  }

  shopItems = [
    {
      heading: 'Panel',
      icon: 'api',
      link: '',
      children: [
        {
          title: 'Inicio Comercio',
          link: 'shop-home',
          icon: 'home',
        },
        {
          title: 'Gestion de Usuario',
          link: 'user-management',
          icon: 'account_circle',
        },
        {
          title: 'Cambiar Contraseña',
          link: 'shop-password',
          icon: 'vpn_key',
        },
      ],
    },
    {
      heading: 'Menú de Artículos',
      icon: 'storefront',
      link: '',
      children: [
        {
          title: 'Menú de  categorías',
          link: 'categories-management',
          icon: 'view_list'
        },
        {
          title: 'Menú de productos',
          link: 'product-management',
          icon: 'menu_open'
        },
        {
          title: 'Extras',
          link: 'additionals',
          icon: 'restaurant',
        },
        {
          title: 'Administrar opcionales',
          link: 'optionals-management',
          icon: 'library_add',
        },
      ]
    },
    {
      heading: 'Administrar descuentos',
      icon: 'local_offer',
      link: 'store-discount',
      children: []
    },
    {
      heading: 'Administrar pedidos',
      icon: 'shopping_cart',
      link: '',
      children: [
        {
          title: 'Pedidos Activos',
          link: 'active-shop-orders',
          icon: 'double_arrow'
        },
        {
          title: 'Pedidos Rechazados',
          link: 'cancelled-shop-orders',
          icon: 'do_disturb'
        },
        {
          title: "Pedidos Completados",
          link: 'completed-shop-orders',
          icon: 'done',
        },
      ]
    },
    {
      heading: 'Reportes',
      icon: 'stacked_line_chart',
      link: '',
      children: [
        //{
        //  title: 'Liquidaciones comercio',
        //  link: 'liquidations',
        //  icon: 'analytics'
        //},
        {
          title: 'Ventas',
          link: 'shop/sales-report',
          icon: 'request_quote'
        },
      ]
    },
    {
      heading: 'Salir',
      icon: 'exit_to_app',
      link: 'login-shop',
      children: []
    }
  ]
}
